import Dropdown from '../../../components/dropdown/Dropdown';
import styles from './area-dropdown.module.less';

const AreaDropdown = ({ currentSelected = '', allRegions = [], onChange: onSelectedChange, label }) => {
    if (!allRegions || allRegions.length === 0 || !Array.isArray(allRegions)) {
        return null;
    }

    const regionsSorted = allRegions.sort();

    return (
        <Dropdown
            onChange={(e) => {
                onSelectedChange(e.target.value ?? '');
            }}
            className={styles.dropdown}
            value={currentSelected ?? ''}
        >
            <option key={label} value={''}>
                {label}
            </option>
            {regionsSorted.map((region) => (
                <option key={region} value={region}>
                    {region}
                </option>
            ))}
        </Dropdown>
    );
};

export default AreaDropdown;
